import {Component, OnInit} from '@angular/core';
import {
  Photo,
  PhotoGallerySettings
} from '../../../widgets/fancy-photo-gallery/fancy-photo-gallery/fancy-photo-classes';
import {
  Animal,
  Rarity,
  Entry,
  Entries
} from '../../../widgets-module/components/animal-rarities/animal-rarities-classes';
import {TripEntry} from '../../../widgets-module/components/trip-list/trip-list.component';
import {NgorongoroText} from "./ngorongoro.text";
import {GoogleMapStyles, Park, Point} from "../../../../google-maps-points";

@Component({
  selector: 'app-Ngorongoro',
  templateUrl: './ngorongoro.component.html',
  styleUrls: ['./ngorongoro.component.css']
})
export class NgorongoroComponent implements OnInit {

  tripEntries: TripEntry[] = [
    new TripEntry({title: 'Big Buck', route: '../../safari/big-buck-safari', iconName: 'buffalo'}),
    new TripEntry({title: 'Culture Quest', route: '../../safari/culture-quest-safari', iconName: 'drum'}),
    new TripEntry({title: 'Lion\'s Share', route: '../../safari/lions-share-safari', iconName: 'lion'})
  ];

  parkText = new NgorongoroText();

  // Animal Rarity Tooltips


  // photo gallery metadata
  zebraPhoto: PhotoGallerySettings = new PhotoGallerySettings({
    iconColor: 'dark',
    photos:
      [
        new Photo({
          title: 'A Refreshing Sip',
          description: 'Two zebras enjoying a refreshing afternoon drink nearby Lake Magadi.',
          thumbnailPath: 'others/zebras-sipping-water.jpg',
          highresPath: '../../assets/img/others/zebras-sipping-water.jpg',
          altPhotoDescription: 'Zebras sipping water.'
        })
      ]
  });
  femaleLionPhoto: PhotoGallerySettings = new PhotoGallerySettings({
    iconColor: 'dark',
    photos:
      [
        new Photo({
          title: 'Is it dinner time yet?',
          description: 'A female lion resting on a shady kopje after finishing a satisfying meal.',
          thumbnailPath: 'others/female-lion-resting.jpg',
          highresPath: '../../assets/img/others/female-lion-resting.jpg',
          altPhotoDescription: 'Female lion resting in the shade'
        })
      ]
  });
  coexistPhoto: PhotoGallerySettings = new PhotoGallerySettings({
    iconColor: 'dark',
    photos:
      [
        new Photo({
          title: 'Don\'t Worry - Be Happy ',
          description: 'A group of grey-crowned crane, thomson gazelle and wildebeest peacefully co-existing amongst one another.',
          thumbnailPath: 'others/coexist.jpg',
          highresPath: '../../assets/img/others/coexist.jpg',
          altPhotoDescription: 'A group of grey-crowned crane, thomson gazelle and wildebeest all standing in a grassy field.'
        })
      ]
  });
  animalEntries: Entries = new Entries({
    entries:
      [
        new Entry({animal: Animal.Lion, rarity: Rarity.Common}),
        new Entry({animal: Animal.Elephant, rarity: Rarity.Common}),
        new Entry({animal: Animal.Buffalo, rarity: Rarity.Common}),
        new Entry({animal: Animal.Hippo, rarity: Rarity.Common}),
        new Entry({animal: Animal.SpottedHyena, rarity: Rarity.Common}),
        new Entry({animal: Animal.Wildebeest, rarity: Rarity.Common}),
        new Entry({animal: Animal.Zebra, rarity: Rarity.Common}),
        new Entry({animal: Animal.BlackRhino, rarity: Rarity.Uncommon}),
        new Entry({animal: Animal.Giraffe, rarity: Rarity.Uncommon}),
        new Entry({animal: Animal.Leopard, rarity: Rarity.Rare}),
      ]
  });

  mapLat = -3.01;
  mapLng = 35.22388458;

  googleMapStyles = GoogleMapStyles; // pull from the global export

  zoom = 9; // default zoom level of the map
  circleWidthsDesktop = ['2.75rem', '3.5rem', '8.5rem', '6.5rem'];
  circleWidthsMobile = ['3rem', '3.75rem', '8.75rem', '6.5rem'];

  parkBoundaries = [
    new Park({
      name: 'Ngorongoro Conservation Area',
      contentId: '/national-parks/ngorongoro',
      defaultColor: '#2A5C88',
      hoverColor: '#1B3B57',
      tooltipOrigin: new Point({lng: 35.22388458, lat: -2.50031231}),
      points:
        [
          new Point({lng: 35.22285461, lat: -2.5013413}),
          new Point({lng: 35.13822556, lat: -2.91081067}),
          new Point({lng: 35.0069046, lat: -2.97972739}),
          new Point({lng: 35.01480103, lat: -3.02292672}),
          new Point({lng: 34.98596191, lat: -3.01298416}),
          new Point({lng: 34.98630524, lat: -2.99515591}),
          new Point({lng: 34.99282837, lat: -2.98418454}),
          new Point({lng: 34.88313675, lat: -2.87669362}),
          new Point({lng: 34.88073349, lat: -3.62803954}),
          new Point({lng: 34.99403, lat: -3.61262085}),
          new Point({lng: 35.03316879, lat: -3.5452895}),
          new Point({lng: 35.0709343, lat: -3.54974415}),
          new Point({lng: 35.12397766, lat: -3.4933742}),
          new Point({lng: 35.1909256, lat: -3.45327922}),
          new Point({lng: 35.20259857, lat: -3.41455341}),
          new Point({lng: 35.27229309, lat: -3.34977843}),
          new Point({lng: 35.33297539, lat: -3.41840892}),
          new Point({lng: 35.40902138, lat: -3.35037822}),
          new Point({lng: 35.44163704, lat: -3.37419808}),
          new Point({lng: 35.4440403, lat: -3.3726558}),
          new Point({lng: 35.52188873, lat: -3.36083161}),
          new Point({lng: 35.51854134, lat: -3.34677948}),
          new Point({lng: 35.54291725, lat: -3.32501543}),
          new Point({lng: 35.55922508, lat: -3.29922355}),
          new Point({lng: 35.58094025, lat: -3.3046219}),
          new Point({lng: 35.61535835, lat: -3.30290814}),
          new Point({lng: 35.6126976, lat: -3.29519618}),
          new Point({lng: 35.65458298, lat: -3.30445053}),
          new Point({lng: 35.66144943, lat: -3.29725271}),
          new Point({lng: 35.69097519, lat: -3.29845235}),
          new Point({lng: 35.70093155, lat: -3.30119438}),
          new Point({lng: 35.70796967, lat: -3.29793822}),
          new Point({lng: 35.71191788, lat: -3.2879983}),
          new Point({lng: 35.73011398, lat: -3.27720138}),
          new Point({lng: 35.75363159, lat: -3.27034613}),
          new Point({lng: 35.75843811, lat: -3.27068889}),
          new Point({lng: 35.76290131, lat: -3.26863231}),
          new Point({lng: 35.77732086, lat: -3.25269364}),
          new Point({lng: 35.79912186, lat: -3.24069664}),
          new Point({lng: 35.85783005, lat: -3.2268142}),
          new Point({lng: 35.8798027, lat: -3.20813261}),
          new Point({lng: 35.90126038, lat: -3.19579228}),
          new Point({lng: 35.9038353, lat: -3.19030765}),
          new Point({lng: 35.90143204, lat: -3.17488195}),
          new Point({lng: 35.90658188, lat: -3.15945603}),
          new Point({lng: 35.90452194, lat: -3.15225718}),
          new Point({lng: 35.90709686, lat: -3.14848634}),
          new Point({lng: 35.9329319, lat: -3.14951475}),
          new Point({lng: 35.96331596, lat: -3.08917948}),
          new Point({lng: 35.95610619, lat: -3.03912602}),
          new Point({lng: 35.93876839, lat: -2.93948363}),
          new Point({lng: 35.94902515, lat: -2.86979293})
        ]
    })
  ];


  constructor() {
  }

  ngOnInit() {
  }

  isMobile() {
    return document.body.clientWidth < 991.98 && document.body.clientWidth > 767.98;
  }

  isMobileBr() {
    return document.body.clientWidth < 500;
  }

}
